import { create } from './create.js';
import { getIndex } from './getIndex.js';

/**
 * Get the cursor for the given selector
 * @param selector
 * @param cursor
 * @returns
 */
export const getCursor = (selector: string, cursor: string | null = null) => {
  const currentCursorIndex = cursor ? getIndex(cursor, 0) : 0;
  const selectorIndex = getIndex(selector, 0);

  return create(Math.max(currentCursorIndex, selectorIndex), null);
};
